'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('./common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('./common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('./common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx('img', {
    src: '//s3.amazonaws.com/cdn.hellofax.com/images/info/signature_modal@2x.png?c=889c43a',
    alt: 'Signature Modal',
    className: 'm-marketing-page--image-signature-modal'
});

module.exports = _react2['default'].createClass({
    displayName: 'eSignatures SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'HelloSign\'s Intro to eSignatures',
            subtitle: 'Already an eSignature pro? Create your HelloSign account and send your first eSignature.',
            buttonText: 'GET ESIGNING'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },

    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _jsx(_bodySection2['default'], {}, void 0, _jsx('h2', {
            className: headerClass
        }, void 0, 'What is an eSignature?'), _jsx('p', {}, void 0, 'According to the ', _jsx('a', {
            href: 'http://www.techlawjournal.com/cong106/digsig/Default.htm',
            target: '_blank'
        }, void 0, 'U.S. Federal ESIGN Act'), ' passed in 2000, an electronic signature is an "electronic sound, symbol, or process, attached to or logically associated with a contract or other record and executed or adopted by a person with the intent to sign the record."'), _jsx('p', {}, void 0, 'In other words, when a signer signs an online document willfully and intentionally, it’s considered an eSignature. An eSignature works largely the same way as a handwritten or “wet” signature.'), _jsx('div', {
            className: 'text-center l-padding-t-60'
        }, void 0, _ref), _jsx('h2', {
            className: headerClass
        }, void 0, 'Are eSignatures secure?'), _jsx('p', {}, void 0, 'eSignatures have been considered a legally binding way to sign documents and paperwork since 2000 and the security of eSignatures depends in large part on the provider of your eSignatures. Here are some of the critical security checkpoints to check off before using any eSignature service:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'SSL hosting'), _jsx('li', {}, void 0, 'Encryption at rest'), _jsx('li', {}, void 0, 'Secure data storage (HelloSign uses an SSAE 16 Certified Data Center)'), _jsx('li', {}, void 0, 'Additional security features like ', _jsx('a', {
            href: 'http://blog.hellosign.com/esignature-two-factor-authentication',
            target: '_blank'
        }, void 0, 'two-factor authentication'), ' and ', _jsx('a', {
            href: 'https://faq.hellosign.com/hc/en-us/articles/205814918-What-Is-An-Audit-Trail',
            target: '_blank'
        }, void 0, 'audit trails'))), _jsx('p', {}, void 0, 'You can learn more about HelloSign\'s security ', _jsx('a', {
            href: '/info/security',
            target: '_blank'
        }, void 0, 'here'), ' and ', _jsx('a', {
            href: 'http://blog.hellosign.com/are-esignatures-secure',
            target: '_blank'
        }, void 0, 'here'), '.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'Are eSignatures legal?'), _jsx('p', {}, void 0, 'Yes! eSignatures are a legally binding and accepted form of signature in the US, Canada, the UK, and parts of the world.'), _jsx('p', {}, void 0, 'As it stands today, 47 of the 50 united states have signed the UETA. The remaining three states (Washington, New York, and Illinois) have passed their own laws regarding the legal status of eSignatures.'), _jsx('p', {}, void 0, 'You can learn more about the legality of eSignatures ', _jsx('a', {
            href: '/info/legal',
            target: '_blank'
        }, void 0, 'here'), ' and ', _jsx('a', {
            href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures',
            target: '_blank'
        }, void 0, 'here'), '.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'Who uses eSignatures?'), _jsx('p', {}, void 0, 'eSignatures are used to sign all types of documents and paperwork, from simple one sheet agreements to complex mortgage and loan paperwork.'), _jsx('p', {}, void 0, 'Here are just a few examples of how eSignatures are being used:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Sales teams are closing deals faster by streamlining the signing process'), _jsx('li', {}, void 0, 'HR directors using eSignatures to simplify complicated onboarding paperwork'), _jsx('li', {}, void 0, 'Real estate agents are signing housing contracts'), _jsx('li', {}, void 0, 'Schools and administrative industries are easily signing applications and releases')), _jsx('h2', {
            className: headerClass
        }, void 0, 'How else are HelloSign eSignatures used?'), _jsx('p', {}, void 0, 'Anyone can use HelloSign’s stand alone product to sign documents or request eSignatures through our website, but many choose to use the HelloSign API to build eSignatures directly into their site.'), _jsx('p', {}, void 0, 'With the HelloSign eSignature API you can:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Keep signers on your page by embedding eSignatures into online paperwork flows'), _jsx('li', {}, void 0, 'Customize the signer\'s experience with white-labeling'), _jsx('li', {}, void 0, 'Remove the extra step of sending signers to a third-party site to sign documents'), _jsx('li', {}, void 0, 'Automate your paperwork to sign documents faster')));
    },

    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Ready to eSign your first document? It only takes a few minutes.',
            subtitle: 'If you’re ready to start eSigning, set up a HelloSign account to try it out. If you want to learn more, schedule a demo and we’ll walk you through all our features.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl,
            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN',
            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },

    render: function render() {
        return _jsx('div', {}, void 0, this.renderTitleSection(), this.renderBodySection(), this.renderCTASection());
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/esignatures.jsx
 ** module id = 829
 ** module chunks = 0
 **/